import * as $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import NewAppointmentForm from '../../../components/authorised/appointment/NewAppointmentForm';
import AppointmentForm from '../../../components/authorised/appointment/AppointmentForm';
import PatientForm from '../../../components/authorised/appointment/PatientForm';
import Moment from 'moment';

import {
  appointmentsLoad,
  appointmentLoad,
  appointmentCreate,
  appointmentUpdate,
  appointmentDelete,
  appointmentEdit,
  appointmentEditCancel,
  appointmentEditHandler,
  onlyAppointmentReset,
  appointmentReconfirm
} from '../../../redux/actions/appointmentActions';

import { patientLoad, patientCreate, patientReset, patientUpdate } from '../../../redux/actions/patient/patientActions';
import Alert from '../../../itrust_common/components/Alert';
import CustomToolTip from '../onboarding/CustomToolTip';
import { onBoardingTourGuideInfoUpdate, onBoardingTourInfoReset, onBoardingTourInfoUpdate } from '../../../redux/actions/onBoardingActions';
import { dateAfterDays, dateFormat, isDateInRange, unixTimeFormat } from '../../../itrust_common/components/HelperFunctions';
import AppointmentModalHeader from './AppointmentModalHeader';
import { change } from 'redux-form';

class Appointment extends Component {

  handleAppointmentsLoad(data) {
    this.props.dispatch(appointmentsLoad(data))
  }

  async handleAppointmentEdit(id, appointmentData) {
    const { appointmentViewMode } = this.props
    if (id === 'New') {
      this.props.dispatch(patientReset());
    } else {
      new Promise((resolve, reject) => {
        this.props.dispatch(appointmentLoad(id, { include: ['patient', 'staff', 'procedures', 'examination'] }))
          .then(response => {
            const patientId = response.value.data.appointment.patient_id;
            resolve(this.handlePatientLoad(patientId))
          })
      })
    }
    await this.props.dispatch(appointmentEdit(id, appointmentData));
    if (appointmentViewMode === 'full') {
      this.handleAppointmentEditHandler({ isFullMode: true, formType: 'new' })
      $('#fullModeAppointment-modal').modal('show')
    }
    else {
      $('#appointmentForm-modal').modal({ backdrop: 'static', keyboard: false })
    }
  }

  handleAppointmentEditCancel() {
    Alert.confirm("Are you sure to close this form? All changes will be reverted.",
      (res) => {
        if (res) {
          this.props.dispatch(appointmentEditCancel());
          this.props.dispatch(onBoardingTourInfoReset())
          $('#appointmentForm-modal').modal('hide')
          $('#fullModeAppointment-modal').modal('hide')
        }
      }
    )
  }

  handleAppointmentDelete(id) {
    const { appointment, dispatch } = this.props
    if (appointment.status == 'complete') {
      return Alert.warning("Completed appointments cannot be updated or deleted.")
    }
    else {
      Alert.deleteConfirm(
        <div>Are you sure you want to cancel the appointment?
          <div>The cancelled record will show in the patient profile, but be removed from the dashboard and calendar.</div>
        </div>,
        (response) => {
          if (response)
            this.props.dispatch(appointmentDelete(id)).then(() => this.handleAppointmentFormClose())
          else {
            dispatch(change('appointmentForm', 'status', appointment.status))
          }
        },
        'Cancel Appointment?'
      )
    }
  }

  validateAppointment(id, data) {
    const { calendarSetting, dateFormatType, appointment } = this.props;
    const { start_time, end_time, procedure_ids, staff_id, } = data

    if (staff_id === null || staff_id === "") {
      return Alert.warning("Please select provider")
    }

    if (!procedure_ids || procedure_ids.length === 0) {
      return Alert.warning("Validation failed: Reason For Visit can't be blank")
    }

    // Check if the appointment start and end within the same day
    const isSameDay = dateFormat(start_time, dateFormatType) === dateFormat(end_time, dateFormatType);
    if (!isSameDay) {
      return Alert.warning("Appointment should ends on the same day.")
    }

    // Check if valid duration
    let isValidDuration = new Date(start_time) < new Date(end_time)
    if (!isValidDuration) {
      return Alert.warning("Appointment duration cannot be zero or less.")
    }

    if (id === '' && calendarSetting.rolling_days_criteria === 'limited_days') {
      // Check if appointment falls within rolling days criteria
      const today = new Date().setHours(0, 0, 0, 0);
      const limitEndDay = unixTimeFormat(dateAfterDays(calendarSetting?.number_of_days));
      const isInRange = isDateInRange(new Date(start_time), new Date(today), new Date(limitEndDay));
      if (!isInRange) {
        return Alert.warning(`You can only create appointments within ${calendarSetting?.number_of_days} days from today.`)
      }
    }

    if (appointment.status == 'complete') {
      return Alert.warning("Completed appointments cannot be updated or deleted.")
    }
    return true
  }

  async handleAppointmentSubmit(data) {
    const { timeSlotFrequency, appointment, storeSpecificPatients, currentStoreId } = this.props
    const id = data.id || '';
    const isValid = this.validateAppointment(id, data)
    if (!isValid) return;

    data = {
      ...data,
      end_day: Moment(new Date(data.start_time).getTime() + timeSlotFrequency * 60000).format("YYYY/MM/DD").toString(),
      start_day: Moment(data.start_time).format("YYYY/MM/DD").toString()
    }

    if (id === '') {
      if (!data.patient_id) {
        if (this.props.handlerData.isFullMode) {
          data = { ...data, patient_id: this.props.patient.id }
          new Promise((resolve, reject) => {
            this.props.dispatch(appointmentCreate(data, { include: ['patient', 'staff', 'procedures'] }))
              .then(response => {
                this.handleAppointmentEditHandler({ isFullMode: false })
                this.handleAppointmentFormClose()
                this.handleAppointmentOnBoardingTour()
              })
          })
        }
        else {
          new Promise((resolve, reject) => {
            if (storeSpecificPatients) {
              data = { ...data, store_ids: [currentStoreId] }
            }
            this.props.dispatch(patientCreate(data))
              .then(response => {
                data = { ...data, patient_id: response.value.data.patient.id }
                resolve(
                  this.props.dispatch(appointmentCreate(data, { include: ['patient', 'staff', 'procedures'] }))
                    .then(() => {
                      this.handleAppointmentFormClose()
                      this.handleAppointmentOnBoardingTour()
                    })
                )
              }).catch(error => {
                if (error.response.data.error == "Patient already exists.") {
                  this.handlePatientAlreadyExist(error.response.data)
                }
              })
          })
        }
      }
      else {
        this.props.dispatch(appointmentCreate(data, { include: ['patient', 'staff', 'procedures'] })).then(() => {
          this.props.dispatch(appointmentEditCancel());
          this.handleAppointmentFormClose()
          this.handleAppointmentOnBoardingTour()
        })
      }
    } else {
      Alert.confirm(
        <div>
          {(appointment.tab_appointment && appointment.staff_id !== data.staff_id) && <><strong>You are changing the provider for the TAB appointment.</strong><br /></>}
          Are you sure to reschedule or edit appointment?
          <span className="d-block">Patient Name: <strong>{data.patient_attributes.name}</strong></span>
          <span className="d-block">Provider: <strong>{data.staff_attributes.name}</strong></span>
          <span className="d-block">Reason For Visit: <strong>{data.procedures_attributes.map(procedure => procedure.name + ' | ')}</strong></span>
        </div>,
        (res) => {
          if (res) {
            new Promise((resolve, reject) => {
              this.props.dispatch(appointmentUpdate(data, { include: ['patient', 'staff', 'procedures'] }))
                .then(response => {
                  this.handleAppointmentFormClose()
                  this.handleAppointmentEditHandler({ isFullMode: false })
                })
            })
          }
        }
      )
    }
  }

  handlePatientAlreadyExist(resObj) {
    const { currentStoreId } = this.props
    Alert.confirm('Patient already exists. Click Continue to add to this store.', async (resOk) => {
      if (resOk) {
        await this.props.dispatch(patientUpdate({ ...resObj.patient, store_ids: [...resObj.patient.store_ids, currentStoreId] }))
        this.handleAppointmentFormClose()
        this.handleAppointmentOnBoardingTour()
      }
    })
  }

  handlePatientLoad(id) {
    this.props.dispatch(patientLoad(id, { include: '*' }));
  }

  handlePatientReset() {
    this.props.dispatch(patientReset());
  }

  handleAppointmentEditHandler(data) {
    this.props.dispatch(appointmentEditHandler(data))
    setTimeout(function () {
      if (data['isFullMode'])
        $('#fullModeAppointment-modal').modal('show');
    }, 500)
  }

  handleAppointmentReconfirm(id) {
    this.props.dispatch(appointmentReconfirm(id))
  }

  componentDidUpdate() {
    if (!this.props.appointmentEditing) {
      this.handleAppointmentFormClose()
    }
  }

  handleAppointmentFormClose() {
    $('#appointmentForm-modal').modal('hide')
    $('#fullModeAppointment-modal').modal('hide')
  }

  componentWillUnmount() {
    // this.props.dispatch(appointmentReset());
    this.props.dispatch(onlyAppointmentReset());
  }

  // onBoarding
  handleAppointmentOnBoardingTour() {
    const { onBoarding: { activeTourType }, history } = this.props
    if (activeTourType === 'create_appointment') {
      history.push(`/dashboard/overview`)
      setTimeout(() => {
        this.props.dispatch(onBoardingTourInfoUpdate({ stepIndex: 3, isTourActive: true, activeTourType: 'create_appointment', moduleTourCompleted: activeTourType }))
        this.props.dispatch(onBoardingTourGuideInfoUpdate({ create_appointment: true }))
      }, 900);
    }
  }

  handleAppointmentTourBackStep() {
    const { onBoarding: { stepIndex } } = this.props
    if (stepIndex === 1) {
      $('#appointmentForm-modal').modal('hide')
      this.props.dispatch(appointmentEditCancel());
      setTimeout(() => this.props.dispatch(onBoardingTourInfoUpdate({ stepIndex: 0, isTourActive: true, activeTourType: 'create_appointment' })), 700);
    }
    else if (stepIndex === 2) {
      this.handleAppointmentEditHandler({ formType: 'default' })
    }
  }

  render() {
    const { appointmentEditing, saving, isFullMode, patient, calendarSetting, procedures, onBoarding, onBoarding: { activeTourType, stepIndex }, formType, dispatch, appointment, isQuickAction } = this.props
    return (
      <span>
        {appointmentEditing &&
          <div className="appointment-modal">
            <div className="modal book-appointment popperAppointment w-0 h-0 position-fixed" id="appointmentForm-modal" data-backdrop="static">
              <div className="modal-dialog mr-10">
                <div className="modal-content border-0 shadow appointment-modal ">
                  <div className="modal-header p-5">
                    <AppointmentModalHeader
                      saving={saving}
                      dispatch={dispatch}
                      formType={formType}
                      appointment={appointment}
                      activeTourType={activeTourType}
                      isTourActive={onBoarding.isTourActive}
                      appointmentEditing={appointmentEditing}
                      handleAppointmentDelete={this.handleAppointmentDelete.bind(this)}
                      handleAppointmentReconfirm={this.handleAppointmentReconfirm.bind(this)}
                      handleAppointmentEditCancel={this.handleAppointmentEditCancel.bind(this)}
                      handleAppointmentEditHandler={this.handleAppointmentEditHandler.bind(this)}
                    />
                  </div>
                  {(appointmentEditing.id === "New" ?
                    <NewAppointmentForm
                      isQuickAction={isQuickAction}
                      procedures={procedures}
                      onSubmit={this.handleAppointmentSubmit.bind(this)}
                      appointmentEditing={appointmentEditing}
                      saving={saving}
                      patient={patient}
                      isFullMode={isFullMode}
                      timeSlotDuration={calendarSetting.time_slot_frequency}
                      handleAppointmentEditHandler={this.handleAppointmentEditHandler.bind(this)}
                      onBoarding={onBoarding}
                    />
                    :
                    <AppointmentForm
                      isQuickAction={isQuickAction}
                      procedures={procedures}
                      onSubmit={this.handleAppointmentSubmit.bind(this)}
                      handleEditCancel={this.handleAppointmentEditCancel.bind(this)}
                      handleDelete={this.handleAppointmentDelete.bind(this)}
                      handleAppointmentReconfirm={this.handleAppointmentReconfirm.bind(this)}
                      appointmentEditing={appointmentEditing}
                      saving={saving}
                      patient={patient}
                      timeSlotDuration={calendarSetting.time_slot_frequency}
                      handleAppointmentEditHandler={this.handleAppointmentEditHandler.bind(this)}
                    />
                  )}
                  {/* belongs to open modal step > its being hard to show Tour Tooltip over modal overlay */}
                  {activeTourType === 'create_appointment' && <>
                    {stepIndex === 1 && <CustomToolTip
                      wrapperClasses="align-tour-tooltip"
                      isRenderCustom={true}
                      hideCloseButton={true}
                      customData={{ index: '2', size: '4' }}
                      title="Create Appointment"
                      description="Add a new patient or search and select an existing patient"
                      handleTourBackStep={() => this.handleAppointmentTourBackStep()}
                    />}
                    {stepIndex === 2 && <CustomToolTip
                      wrapperClasses="align-tour-tooltip"
                      isRenderCustom={true}
                      hideCloseButton={true}
                      customData={{ index: '3', size: '4' }}
                      title="Create Appointment"
                      description={`${formType === 'existing' ? 'Select Reason For Visit' : 'Add Basic Details, Select Reason For Visit and Click on Save'}`}
                      handleTourBackStep={() => this.handleAppointmentTourBackStep()}
                    />}
                  </>}
                </div>
              </div>
            </div>
          </div>
        }
        {appointmentEditing && isFullMode &&
          <div className="exam-setting-modal">
            <div className="modal fade" id="fullModeAppointment-modal" tabIndex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
              <div className="modal-dialog m-0" role="document">
                <div className="modal-content bg-light">
                  <div className="d-flex flex-row h-100">
                    <PatientForm />
                    <div className="w-25 position-fixed appointment-form h-100">
                      <div className="bg-white appointment-form-height shadow-sm">
                        <AppointmentForm
                          isFullMode={isFullMode}
                          procedures={procedures}
                          onSubmit={this.handleAppointmentSubmit.bind(this)}
                          handleEditCancel={this.handleAppointmentEditCancel.bind(this)}
                          handleDelete={this.handleAppointmentDelete.bind(this)}
                          handleAppointmentReconfirm={this.handleAppointmentReconfirm.bind(this)}
                          appointmentEditing={appointmentEditing}
                          saving={saving}
                          patient={patient}
                          handleAppointmentEditCancel={this.handleAppointmentEditCancel.bind(this)}
                          timeSlotDuration={calendarSetting.time_slot_frequency}
                          handleAppointmentEditHandler={this.handleAppointmentEditHandler.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </span>
    )
  }
}

const mapStateToProps = state => {
  const { appointment, patient, setting: { calendarSetting }, procedurePricing, onBoarding, organisation: { organisation }, currentStore } = state
  return {
    appointment: appointment.appointment,
    procedures: procedurePricing.procedure_pricings,
    isFullMode: appointment.handlerData.isFullMode,
    patient: patient.patient,
    appointmentEditing: appointment.editing,
    formType: appointment.handlerData.formType,
    handlerData: appointment.handlerData,
    saving: appointment.saving,
    calendarSetting: calendarSetting.calendar_setting,
    appointmentViewMode: calendarSetting.calendar_setting.preferences?.appointment_view_mode,
    onBoarding,
    appointment: appointment.appointment,
    timeSlotFrequency: calendarSetting.calendar_setting.time_slot_frequency,
    dateFormatType: organisation.preferences?.date_format,
    storeSpecificPatients: organisation.preferences?.store_specific_patients,
    currentStoreId: currentStore.store.id,
  }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(Appointment);
